import React from 'react'
import './Background.css'

function Background() {
  return (
      <div class="bg"></div>
  )
}

export default Background
